import MobileMechanics from './MobileMechanics';

export default MobileMechanics;
